import { apiUrls } from "../utils/api";

export async function updateSettings(target, config, updatePersonalSetting, apiClient) {
  const resp = await apiClient.get(apiUrls.GetSettings);
  const { settings, settingGroups } = await resp.json();

  const group = settingGroups.find((i) => i.Description === target).PK_SettingGroup;
  const setting = settings.find((i) => (i.FK_SettingGroup === group) && (i.IsCompanySetting !== updatePersonalSetting));

  const Value = Object.assign(JSON.parse(setting.Value || "{}"), config);

  return await apiClient.post(apiUrls.SaveSettings, [{
    ...setting,
    Value: JSON.stringify(Value),
  }]);
}
